import { Navigate, useLocation } from 'react-router-dom';
import { useTypedSelector } from '@redux/store';
import * as selectors from '@redux/selectors';
import { ReactNode } from 'react';
import { shallowEqual } from 'react-redux';

interface RegistrationCheckMiddlewareProps {
    children: ReactNode;
}

const RegistrationCheckMiddleware: React.FC<RegistrationCheckMiddlewareProps> = ({ children }) => {
    const { loggedInDetails } = useTypedSelector((state) => ({
        loggedInDetails: selectors.loggedInDetails(state),
    }),shallowEqual);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);


    // Bypass this middleware for specific paths
    if (location.pathname === '/register' ||
        location.pathname === '/locked' ||
        location.pathname === '/blocked' ||
        location.pathname === '/cancel-membership' ||
        location.pathname === '/terms-conditions' ||
        location.pathname === '/redirect') {
        return <>{children}</>;
    }

    if (loggedInDetails && Object.keys(loggedInDetails).length > 0) {
        let navigateTo = null;

        if (!loggedInDetails?.isLoggedIn) {
            navigateTo = '/';
        } else if (loggedInDetails?.isLocked) {
            navigateTo = '/locked';
        } else if (loggedInDetails?.isBlocked) {
            navigateTo = '/blocked';
        } else if (loggedInDetails?.isDeactivated) {
            navigateTo = '/cancel-membership';
        } else if (!loggedInDetails?.isRegistered) {
            navigateTo = '/register';
        }

        if (navigateTo) {
            const newSearch = searchParams.toString();
            const finalPath = newSearch ? `${navigateTo}?${newSearch}` : navigateTo;
            return <Navigate to={finalPath} />;
        }
    } else {
        const newSearch = searchParams.toString();
        const finalPath = newSearch ? `/?${newSearch}` : '/';
        return <Navigate to={finalPath} />;
    }

    return <>{children}</>;
};

export default RegistrationCheckMiddleware;